import { render, staticRenderFns } from "./ModalMedicineAction.vue?vue&type=template&id=36189e3e"
import script from "./ModalMedicineAction.vue?vue&type=script&lang=js"
export * from "./ModalMedicineAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports